module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAwIiBoZWlnaHQ9IjYwMCIgdmlld0JveD0iMCAwIDYwMCAzMDAiPjxwYXRoIGZpbGw9IiM2Q2YiIGQ9Ik0wIDBoNjAwdjMwMEgweiIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0yMDAgMjc0bDEwMC0xNCAxMDAgMTRMMzAwIDI3eiIvPjxwYXRoIGQ9Ik0yMTMuNSAyNzRsODYuNS0xNCA4Ni41IDE0TDMwMCA2MHoiLz48cGF0aCBmaWxsPSIjRkNEMTE2IiBkPSJNMjAwIDI3NGgyMDBMMzAwIDE1MHoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/lca.svg
// module id = 0Eji
// module chunks = 0